import { matchMedia, scrollWindow } from 'actions/global';

export const addMatchMediaListener = store => {
	const phoneMedia = window.matchMedia('(max-width: 719px)');
	const tabletMedia = window.matchMedia('(max-width: 1199px) and (min-width: 720px)');
	const desktopMedia = window.matchMedia('(min-width: 1200px)');

	const handleMediaChange = callback => media => {
		if (media.matches) {
			callback();
		}
	};

	phoneMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('phone'))));
	tabletMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('tablet'))));
	desktopMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('desktop'))));

	// Initalize
	handleMediaChange(() => store.dispatch(matchMedia('phone')))(phoneMedia);
	handleMediaChange(() => store.dispatch(matchMedia('tablet')))(tabletMedia);
	handleMediaChange(() => store.dispatch(matchMedia('desktop')))(desktopMedia);
};

export const createScroller = store => {
	let ticking = false;

	const scrollEvent = () => {
		const { scrollY } = window;

		if (!ticking) {
			window.requestAnimationFrame(() => {
				store.dispatch(scrollWindow(scrollY));
				ticking = false;
			});
		}
		ticking = true;
	};

	const addListener = () => {
		window.addEventListener('scroll', scrollEvent, false);
		// Initalize the scroll value
		store.dispatch(scrollWindow(window.scrollY));
	};

	const removeListener = () => {
		window.removeEventListener('scroll', scrollEvent);
	};

	return {
		addListener,
		removeListener,
	};
};



// WEBPACK FOOTER //
// ./src/util/event.js